<template>
  <el-row :gutter="10">
    <el-col :span="6">
      <left-table />
    </el-col>
    <el-col :span="18">
      <right-table />
    </el-col>
  </el-row>
</template>
<script>
import LeftTable from './components/left-table/index.vue'
import RightTable from './components/right-table/index.vue'
export default {
  name: 'researchDictionary',
  components: {
    LeftTable,
    RightTable,
  },
}
</script>
